@if (dashboardWidgetConfiguration) {
    <div class="dashboardWidgetContainer">
        <h2>{{ dashboardWidgetConfiguration.title }}</h2>
        @if (dashboardWidgetConfiguration.data && dashboardWidgetConfiguration.data.length > 0) {
            <div class="listContainer">
                <div class="listHeader">
                    @for (label of dashboardWidgetConfiguration.labels; track label) {
                        <span>{{ label }}</span>
                    }
                </div>
                @if (dashboardWidgetConfiguration && dashboardWidgetConfiguration.data) {
                    <div class="list">
                        @for (item of dashboardWidgetConfiguration.data; track item) {
                            <div class="listItem">
                                @if (item.value) {
                                    <span>
                                        <span
                                            class="linkLike"
                                            (click)="onListItemClick(item.value)"
                                            title="{{ dashboardWidgetConfiguration.navigationTitle }}"
                                        >
                                            {{ item.name }}
                                        </span>
                                    </span>
                                }
                                @if (item.date) {
                                    <span class="date">{{ item.date | date: 'yyyy-MM-dd hh:mm' }}</span>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        } @else {
            <div class="noDataContainer">
                <p class="noDataText">{{ dashboardWidgetConfiguration.noDataText }}</p>
            </div>
        }
    </div>
}
